module.exports = __webpack_public_path__ + "c41dfd9e5a20eeb613b45f423c1ffa84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-parvulo-head.png
// module id = 108
// module chunks = 0